/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResourcesUserDistribution } from '../../models/paged-resources-user-distribution';

export interface GetRuleDistributions$Params {
  'Active-Tenant-Identifier': string;
  ruleId: string;
  page?: number;
  size?: number;
}

export function getRuleDistributions(http: HttpClient, rootUrl: string, params: GetRuleDistributions$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResourcesUserDistribution>> {
  const rb = new RequestBuilder(rootUrl, getRuleDistributions.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('ruleId', params.ruleId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResourcesUserDistribution>;
    })
  );
}

getRuleDistributions.PATH = '/distribution-rules/{ruleId}/distributions';
